var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    y: 0.283203,
    width: 24,
    height: 24.05,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03168 19.3238C15.0694 19.3238 18.3718 14.3111 18.3718 9.96418C18.3718 9.82181 18.3718 9.68007 18.3622 9.53898C19.0047 9.07331 19.5592 8.49675 20 7.83624C19.4009 8.10227 18.7653 8.27677 18.1146 8.3538C18.7998 7.9427 19.3128 7.29611 19.5578 6.53433C18.9133 6.91753 18.2084 7.18753 17.4732 7.33279C16.2301 6.00812 14.1506 5.94418 12.8287 7.18997C11.9761 7.99337 11.6144 9.19061 11.879 10.333C9.23962 10.2004 6.78048 8.95107 5.1136 6.89605C4.2423 8.39914 4.68736 10.322 6.12992 11.2873C5.60749 11.2717 5.09651 11.1305 4.64 10.8755V10.9172C4.64045 12.4831 5.74189 13.8317 7.2736 14.1418C6.79034 14.2739 6.28326 14.2932 5.79136 14.1983C6.22138 15.5383 7.45382 16.4563 8.85824 16.4827C7.69581 17.3982 6.25984 17.8952 4.78144 17.8936C4.52026 17.8931 4.25933 17.8773 4 17.8462C5.50118 18.8116 7.24794 19.3236 9.03168 19.3212",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.f42f33adef27b76efe97f1272d811e73.svg";
export { ForwardRef as ReactComponent };